<template>
  <div id="page0"
    :class="{
    'main-cover-container': true,
    'fade-out': PAGE_INDEX !== currentPage,
  }"
  >
    <div class="main-cover">
      <div :class="{
          'background-image': true,
          'dark': coverStep >= 1,
        }"
      >
        <!-- <img :src="coverSrc" alt="夜空"> -->
      </div>
      <div :class="{
          'cover-text-wrapper': true,
          'shining-animation': coverStep === 0,
          'enlarge': coverStep === 1,
          'dark': coverStep === 2,
        }"
      >
        <TimeText :coverShakeFlag="coverStep === 1"></TimeText>
      </div>
      <div :class="{
          'title-wrapper': true,
          'fly-in': coverStep === 2,
        }"
      >
        <!-- <div class="sub-title">
          <span class="sub-title-digit">9</span>
          <span class="sub-title-digit">2</span>
          <span class="sub-title-digit">1</span>
          地震廿周年
        </div> -->
        <img :src="coverSrc" alt="天亮之後 921二十週年">
      </div>
    </div>
    <div
      v-show="currentPage === 0"
      class="scroll-down-arrow-wrapper"
    >
      <ScrollDownArrow></ScrollDownArrow>
    </div>
  </div>
</template>

<script>
import ScrollDownArrow from '../ScrollDownArrow.vue';
import TimeText from './TimeText.vue';

export default {
  name: 'MainCover',
  components: {
    ScrollDownArrow,
    TimeText,
  },
  props: {
    PAGE_INDEX: {
      type: Number,
      require: true,
    },
    currentPage: {
      type: Number,
      require: true,
    },
    coverStep: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    coverSrc() {
      if (window.innerWidth < 768) {
         return require('../../assets/images/cover/en_921_page_title_white.png');
      } else {
        return require('../../assets/images/cover/en_921_page_title_white_pc.png');
      }
    },
    // coverSrc() {
    //   if (window.innerWidth < 768) {
    //     return require('../../assets/images/cover/921_page_CoverBackground.jpg');
    //   } else if (window.innerWidth >= 768 && window.innerWidth < 1280) {
    //     return require('../../assets/images/cover/921_page_CoverBackgroundiPad1@2x.jpg');
    //   } else {
    //     return require('../../assets/images/cover/web/921_page_CoverBackgroundPC.jpg');
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
  .main-cover-container {
    position: relative;
    z-index: 10;
    width: 100%;
    transition: .666s ease-in-out;
    overflow: hidden;
    .main-cover {
      position: relative;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #000000;
      color: #ffffff;
      font-size: 48px;
      .title-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity 2s linear;
        margin-bottom: 15%;
        @media (min-width: 1025px) {
          margin-bottom: 5%;
        }
        img {
          height: 50vh;
          @media (min-width: 768px) {
            transform: translateX(calc(50% - 45px));
          }
        }
        .sub-title {
          position: absolute;
          bottom: 0;
          left: -30px;
          height: 100%;
          text-align: right;
          writing-mode: vertical-lr;
          font-size: 16px;
          color: #57b09f;
          letter-spacing: 0.2rem;
          .sub-title-digit {
            margin: 0;
            letter-spacing: 0;
            line-height: 1;
            writing-mode: horizontal-tb;
          }
        }
      }
      .fly-in {
        animation-name: flyInAnimation;
        animation-duration: 2s;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
        @keyframes flyInAnimation {
          0% {
            opacity: 0;
            transform: translateY(50px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
      .cover-text-wrapper {
        position: absolute;
        top: 20%;
        left: 0;
        width: 100%;
        padding: 0 10%;
        @media (min-width: 768px) and (max-width: 1279px) {
          padding: 0 20%;
        }
        @media (min-width: 1280px) {
          top: 30%;
          padding: 0 15%;
        }
      }
      .background-image {
        position: absolute;
        bottom: -25%;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: cover;
        background-position: center bottom;
        background-image: url('../../assets/images/cover/921_page_CoverBackground.jpg');

        transition: opacity .666s ease-in-out;
        @media (min-width: 768px) and (max-width: 1279px) {
          bottom: -10%;
          height: 100%;
          background-image: url('../../assets/images/cover/921_page_CoverBackgroundiPad1@2x.jpg');
        }
        @media (min-width: 1280px) {
          bottom: -5%;
          background-image: url('../../assets/images/cover/web/921_page_CoverBackgroundPC.jpg');
        }
        // img {
        //   height: 100%;
        // }
      }
      .enlarge {
        animation-name: enlargeAnimation;
        animation-duration: 5s;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
        @keyframes enlargeAnimation {
          0% {
            opacity: 1;
            transform: scale(1);
          }
          60% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: scale(1.1);
          }
        }
      }
      .dark {
        opacity: 0;
      }
    }
    .shining-animation {
      animation: shiningAnimation 2s infinite ease-in-out;
      @keyframes shiningAnimation {
        0% {
          opacity: 0;
        }
        20% {
          opacity: 1;
        }
        80% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
    }
    .fixed {
      position: fixed;
      top: 0;
    }
  }

  .fade-out {
    transform: translateY(-100vh);
    opacity: 0;
  }

  .scroll-down-arrow-wrapper {
    position: fixed;
    left: 0;
    bottom: 10%;
    width: 100%;
    text-align: center;
  }

</style>
